import { WorkerClient } from '../worker/workerClient.js';
import { setStateVersion } from '../state/store.js';

const URLENCODED = 'application/x-www-form-urlencoded; charset=UTF-8';

const client = new WorkerClient();

function buildActionUrl(action) {
  const path = window.location.pathname + window.location.search;
  const separator = path.indexOf('?') === -1 ? '?' : '&';
  const relative = path + separator + 'ajax=1&action=' + encodeURIComponent(action);

  return new URL(relative, window.location.origin).href;
}

function encodeBody(data) {
  if (data === undefined || data === null) {
    return '';
  }

  if (typeof data === 'string') {
    return data;
  }

  if (data instanceof URLSearchParams) {
    return data.toString();
  }

  const params = new URLSearchParams();

  Object.keys(data).forEach((key) => {
    const value = data[key];

    if (Array.isArray(value)) {
      value.forEach((item) => params.append(key + '[]', item));
    } else if (value !== undefined && value !== null) {
      params.append(key, value);
    }
  });

  return params.toString();
}

function applyStateVersion(json) {
  if (json && typeof json === 'object' && typeof json.stateVersion === 'string') {
    setStateVersion(json.stateVersion);
  }

  return json;
}

export function postAction(action, data) {
  const payload = {
    url: buildActionUrl(action),
    method: 'POST',
    headers: {
      'Content-Type': URLENCODED,
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: encodeBody(data),
  };

  return client.request(payload).then((result) => applyStateVersion(result.json));
}
